export default "__VITE_ASSET__CpAqrU9N__"